/**
 * Rather than add yet another field to global window, use this to check anyway we want to check
 * currentFlavor === 'develop' || currentFlavor === 'teamwork'
 */
export function currentFlavorSupportsTeams(): boolean {
  return (
    window.currentFlavor === 'develop' || window.currentFlavor === 'teamwork'
  );
}
